import React from 'react';
import styles from './MissingImage.module.css';
import { NoPhotographyIcon } from 'components/Icons/NoPhotography';
import { Popup } from 'semantic-ui-react';

interface IProps {
    tooltip?: string;
}

export const MissingImage = ({ tooltip, ...props }: React.HTMLProps<HTMLDivElement> & IProps) => {
    return (
        <Popup
            trigger={
                <div className={styles.missingImage} {...props}>
                    <NoPhotographyIcon width={22} data-testid="camera-icon" />
                </div>
            }
            on="hover"
            wide="very"
            position="top center"
            inverted
        >
            {tooltip}
        </Popup>
    );
};
